import URI from 'urijs';
import omit from 'lodash.omit';
import queryString from 'query-string';

export const getUrlParams = ({ search }) => queryString.parse(search);

export const updateSearchObject = (location, toOmit, toAdd) => {
    return { ...omit(getUrlParams(location), [...toOmit]), ...toAdd };
};

export const updateSearchString = (location, toOmit, toAdd) =>
    queryString.stringify(updateSearchObject(location, toOmit, toAdd));

export const constructUrlObject = (url, params) =>
    URI(document.location.origin + url)
        .query(params)
        .build();

export const getUrlString = (url, params) => URI(url).query(params).build().toString();

export const getNavigationUrl = (location, path, additionalParams) => {
    const params = getUrlParams(location);
    return getUrlString(path, {
        applicationSid: params.applicationSid,
        district: params.district,
        school: params.school,
        classe: params.classe,
        period: params.period,
        ...additionalParams,
    });
};
